export default `# Avatar Catalog

The avatar catalog is your library of AI personas. Browse, create, and manage the avatars available for sessions.

---

## Browsing Avatars

The table displays all avatars with sortable columns:

| Column | Description |
|--------|-------------|
| Name | Avatar identity |
| Category | Facilitator, Domain Expert, Stakeholder, Researcher, or Custom |
| Scope | Where the avatar is available (Session, User, Organization) |
| Status | Draft, Pending Review, Approved, or Rejected |
| Features | KB (Knowledge Base), Device (physical hardware support) |
| Version | Iteration number |

### Filtering
- **Search** by name, description, or keywords
- **Scope filter** — Session, User, or Organization
- **Public only** — Show only published avatars
- **Latest only** — Hide older versions

---

## Avatar Actions

| Action | Description |
|--------|-------------|
| Click row | Open avatar for editing |
| Copy icon | Clone the avatar with a new name |
| Download icon | Export the avatar's SOP (Standard Operating Procedure) |
| Send icon | Submit a draft for review (draft only) |
| Delete icon | Remove the avatar (draft only) |

---

## Creating Avatars

Click **Create Avatar** to build a new persona. The builder walks you through:
- Name, description, and category
- Personality traits and expertise areas
- TTS voice selection
- Knowledge Base configuration
- Physical device support

---

## Avatar Groups

Click **Avatar Groups** to manage pre-configured teams of avatars. Groups let you quickly assign a curated set of avatars when creating a session, rather than selecting them individually.

---

## Scopes

| Scope | Visibility | Who can create |
|-------|-----------|----------------|
| Session | One-time use in a specific session | Anyone |
| User | Your personal avatar library | Anyone |
| Organization | Shared across your organisation | Admins (via review) |

---

## Publishing Workflow

1. **Draft** — Create and iterate freely
2. **Pending Review** — Submit for admin approval
3. **Approved** — Available to the organisation
4. **Rejected** — Needs changes (feedback provided)

Only Draft avatars can be edited or deleted. Approved avatars are read-only — clone them to make changes.

---

## Tips

- **Clone rather than start from scratch** — If an existing avatar is close to what you need, clone it and modify
- **Use descriptive names and roles** — These appear in session panels, so clarity helps facilitators
- **Version your changes** — Each edit increments the version, making it easy to track evolution
- **Download SOPs** for documentation — Useful for sharing avatar designs with stakeholders outside the platform`;
